import { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import EvidencijeObrazac11Dodavanje from "./EvidencijeObrazac11Dodavanje";
import { useGlobalContext } from "../../../../Context/Context";
import axios from "axios";

const SIGNATURE_URL = "https://data.nadzor.app/potpis.jpg";

function EvidencijeObrazac11() {
  const [data, setData] = useState([]);
  const [isDodavanje, setIsDodavanje] = useState(false);

  const { selectedMainEntity, baseUrl } = useGlobalContext();

  const fetchData = async () => {
    try {
      const { data: res } = await axios.post(
        `${baseUrl}/evidencija11/read.php`,
        {
          company_id: selectedMainEntity.company_id,
        },
      );
      if (res.status === 200) setData(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    fetchData();
  }, [selectedMainEntity]);

  const handleStampaj = async () => {
    const el = document.getElementById("print-obrazac11");
    if (!el) return;

    const useSignature = window.confirm(
      "Da li želite da dodate stranicu sa potpisom?",
    );
    let signatureHtml = "";
    if (useSignature) {
      signatureHtml = `<div style="page-break-before:always;"><div id="sig-page" style="width:287mm;height:200mm;margin:0 auto;position:relative;overflow:hidden;background:#fff;"><img id="signature-img" src="${SIGNATURE_URL}" style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:block;"/></div></div>`;
    }

    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Popup blokiran.");
      return;
    }

    printWindow.document.write(
      `<html><head><meta charset="utf-8"/><style>@page{size:A4 landscape;margin:5mm 5mm 15mm 5mm;}body{margin:0;padding:5mm;font-family:sans-serif;font-size:12px;}table{width:100%;border-collapse:collapse;}td{border:1px solid black;padding:2px;font-size:12px !important;vertical-align:top;}hr{width:80%;margin:0 auto;margin-bottom:5px;}</style></head><body>${el.innerHTML}${signatureHtml}</body></html>`,
    );
    printWindow.document.close();
    printWindow.onload = () => {
      const doPrint = () => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };
      const img = printWindow.document.getElementById("signature-img");
      const box = printWindow.document.getElementById("sig-page");
      if (box) {
        const footer = Array.from(
          printWindow.document.querySelectorAll("div"),
        ).find(
          (d) =>
            d.textContent?.includes("Саветник/сарадник") &&
            d.textContent?.includes("Послодавац"),
        );
        if (footer) footer.remove();
      }
      if (!img || !box) return doPrint();
      const fitAndPrint = () => {
        const nW = img.naturalWidth || 1;
        const nH = img.naturalHeight || 1;
        img.style.transform = `translate(-50%, -50%) rotate(${nW > nH ? -90 : 0}deg)`;
        doPrint();
      };
      if (img.complete && img.naturalWidth) fitAndPrint();
      else {
        img.onload = fitAndPrint;
        img.onerror = doPrint;
      }
    };
  };

  const {  loggedUser, apiKey } = useGlobalContext();
  const [header, setHeader] = useState({ name: "", address: "", pib: "" });
  useEffect(() => {
    const fetchHeader = async () => {
      const id = selectedMainEntity?.company_id || selectedMainEntity?.id;
      if (!id || !loggedUser?.id) return;
      try {
        const { data: res } = await axios.post(`${baseUrl}/companies/readCompanyDetails.php`, {
          user_id: loggedUser.id,
          api_key: apiKey,
          company_id: id,
        });
        if (res.status === 200) setHeader({
          name: res.data.company_name,
          address: res.data.company_address,
          pib: res.data.pib
        });
      } catch (e) { console.error(e); }
    };
    fetchHeader();
  }, [selectedMainEntity, loggedUser?.id]);

  return (
    <div
      style={{
        fontSize: "12px",
        height: "100%",
        width: "100%",
        backgroundColor: "rgb(204,204,204)",
      }}
    >
      <style>{`#print-obrazac11 td, #print-obrazac11 th { font-size: 12px !important; }`}</style>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <div
          id="print-obrazac11"
          style={{
            overflowY: "auto",
            backgroundColor: "white",
            padding: "40px",
            border: "1.5px solid #9f9f9f",
            height: "100%",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              textAlign: "center",
              textTransform: "uppercase",
            }}
          >
            <div>Образац 11</div>
            <div>ЕВИДЕНЦИЈА О ИЗДАТОЈ ЛИЧНОЈ ЗАШТИТНОЈ ОПРЕМИ</div>
          </div>
          <br />
          <br />

          <div style={{ display: "flex" }}>
            <div style={{ width: "33%", textAlign: "center" }}>
              {selectedMainEntity.company_name}
              <hr
                style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }}
              />
              Пословно ime послодавца
            </div>
            <div style={{ width: "33%", textAlign: "center" }}>
              {header.address}
              <hr
                style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }}
              />
              Адреса седишта послодавца
            </div>
            <div style={{ width: "33%", textAlign: "center" }}>
              {header.pib}
              <hr
                style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }}
              />
              ПИБ послодавца
            </div>
          </div>
          <br />
          <br />

          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <td style={styles.cell}>Редни број</td>
                <td style={styles.cell}>
                  Подаци о личној заштитној опреми према акту о процени ризика
                  (врста, ознака стандарда и др.)
                </td>
                <td style={styles.cell}>Радно место</td>
                <td style={styles.cell}>Датум издавања</td>
                <td style={styles.cell}>
                  Рок трајања (ако постоји према упутству произвођача)
                </td>
                <td style={styles.cell}>
                  Име и презиме лица које је издало личну заштитну опрему
                </td>
                <td style={styles.cell}>
                  Назив документа о задужењу личне заштитне опреме (реверс,
                  картон задужења, отпремница и сл.)
                </td>
              </tr>
            </thead>
            <tbody>
              {data.map((item, i) => (
                <tr key={item.id}>
                  <td style={styles.cell}>{i + 1}.</td>
                  <td style={styles.cell}>
                    {item.lzo_naziv}
                    {item.lzo_standard ? ` – ${item.lzo_standard}` : ""}
                  </td>
                  <td style={styles.cell}>{item.radno_mesto_naziv}</td>
                  <td style={styles.cell}>{item.datum}</td>
                  <td style={styles.cell}>
                    {item.rok_meseci ? `${item.rok_meseci} mesec(i)` : ""}
                  </td>
                  <td style={styles.cell}>{item.zaposleni_naziv}</td>
                  <td style={styles.cell}>{item.naziv_dokumenta}</td>
                </tr>
              ))}
              {data.length === 0 && (
                <tr>
                  {Array.from({ length: 7 }).map((_, i) => (
                    <td key={i} style={styles.cell}></td>
                  ))}
                </tr>
              )}
            </tbody>
          </table>
          <br />
          <br />

          <div style={{ display: "flex" }}>
            <div style={{ width: "70%", textAlign: "center" }}>
              <hr
                style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }}
              />
              Саветник/сарадник за безбедност и здравље на раду
            </div>
            <div style={{ width: "30%", textAlign: "center" }}>
              <hr
                style={{ width: "80%", margin: "0 auto", marginBottom: "5px" }}
              />
              Послодавац
            </div>
          </div>
        </div>

        <div style={{ marginTop: "15px" }}>
          {isDodavanje ? (
            <EvidencijeObrazac11Dodavanje
              setIsDodavanje={setIsDodavanje}
              onRefresh={fetchData}
            />
          ) : (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", gap: "10px" }}>
                <div onClick={handleStampaj}>
                  <Button activation={true} style={styles.button}>
                    ШТАМПАЈ
                  </Button>
                </div>
                <Button activation={true} style={styles.button}>
                  ПОШАЉИ
                </Button>
              </div>
              <div onClick={() => setIsDodavanje(true)}>
                <Button activation={true} style={styles.button}>
                  ДОДАЈ
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EvidencijeObrazac11;
